import { z } from 'zod';

export const CulinaryStudioArticleIncludedServiceModelSchema = z.object({
    name: z.string(),
    description: z.any().optional().nullable(),
});

export type CulinaryStudioArticleIncludedServiceModel
    = z.infer<typeof CulinaryStudioArticleIncludedServiceModelSchema>;
